<template>
    <div class="pt-8">
        <FilterForm 
            :filter="filter" 
            @get-categories-list-empresa="getCategoriesListEmpresa()" 
            @clear-filter-form="clearFilterForm()" 
        />
        
        <CategoriesTable 
            :categories="categories" 
            :paginator="paginator" 
            :pageSize="pageSize"  
            @get-categories-list-empresa="getCategoriesListEmpresa()" 
            @change-page="changePage($event)" 
            @update-status-category="updateStatusCategory($event)"
        />
    </div>
</template>
<script>
import FilterForm from '../components/FilterForm.vue'
import CategoriesTable from '../components/CategoriesTable.vue'
import { mapActions, mapMutations } from "vuex";
export default {
    data(){
        return{
            categories: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
            message: "",
            filter: {
                nombre: '',
                codigo: '',
            }

        }
    },
    components: {
        FilterForm,
        CategoriesTable
    },
    created(){
        this.getCategoriesListEmpresa();
    },
    methods:{      
         ...mapActions('configuration', {
          _getCategoriesEmpresa: 'getCategoriesEmpresa',
        }),    
        ...mapMutations(['setLoading']),
        async getCategoriesListEmpresa(){
            this.pageOptions = {
                pageNumber: this.paginator.page, 
                pageSize:   this.paginator.pageSize,
                nombre:     this.filter.nombre,
                codigo:     this.filter.codigo
            }
            this.setLoading(true)
            await this.$conectar.post('/empresa/categories/get-categories-list-empresa', this.pageOptions)
            .then(response =>{
                this.categories = response.data.categoriesListsEmpresa;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getCategoriesListEmpresa();
        },
        async updateStatusCategory(item){
            item.status = !item.status
            this.data = {category_id: item.id, status: item.status}
            this.setLoading(true)
            await this.$conectar.post('/empresa/categories/update-status-category', this.data)
            .then(response =>{
                if(response.data.error == true){
                    item.status = !item.status;
                    this.$bvToast.toast(response.data.errorMessage, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
                
                this._getCategoriesEmpresa();
            })
            .catch(e => {
                console.log(e);
                item.status = !item.status;
                this.$bvToast.toast("Parece que hubo un error en el servidor, por favor intente mas tarde, si el problema persiste, contacte al administrador.", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
                
            })
            this.setLoading(false)
        },
        clearFilterForm(){
            this.filter.nombre = "";
            this.filter.codigo = "";
        }
    }
}
</script>